import BadgesGridComponent from "./badges-grid-component";
import BadgesGridConfig from "./badges-grid-config";
import BadgesGridAdvancedConfig from "./badges-grid-advanced-config";

export default {
  BadgesGridComponent,
  BadgesGridConfig,
  BadgesGridAdvancedConfig
};
